//import Vue from 'vue'
//import Router from 'vue-router'
import store from './store'
import { createRouter, createWebHashHistory } from 'vue-router'

const WeekOverview = () => import('./views/WeekOverview.vue');
//const Dashboard = () => import('./views/Dashboard-' + process.env.VUE_APP_MODAL);
const CreateErrand = () => import('./views/CreateErrand.vue');
const CreateErrandCustom = () => import('./views/CreateErrandCustom.vue');
const ErrandRequest = () => import('./views/ErrandRequest.vue');
const ClassicView = () => import('./views/Classic.vue');

const Start = () => import('./views/Start.vue');
const DashboardEdit = () => import('./views/DashboardEdit.vue');

const CustomerList = () => import('./views/Customers/List.vue');
const CustomerDetails = () => import('./views/Customers/Details.vue');
const NewCustomer = () => import('./views/Customers/New.vue');

const InvoiceSummaryList = () => import('./views/InvoiceSummary/List.vue');
const DocumentIndex = () => import('./views/Documents/Wrapper.vue')
const ResourceGroupsList = () => import('./views/Admin/ResourceGroupsList.vue');

const ProjectAdminOverview = () => import('./views/Admin/ProjectOverview.vue');
const ArticlesOverview = () => import('./views/Admin/ArticlesOverview.vue');

const ArticleFavorites = () => import('./views/Admin/ArticleFavorites.vue');

const CodexQueue = () => import('./views/Admin/CodexQueue.vue');

const MessageQueue = () => import('./views/Admin/message-queue.vue');
const MessageQueue2 = () => import('./views/Admin/message-queue-2.vue');


const ProjectList = () => import('./views/Projects/List.vue');
const ProjectOverview = () => import('./views/Projects/Overview.vue');


const TaskTypeOverview = () => import('./views/Admin/TaskTypeOverview.vue');
const RootRegister = () => import('./views/Admin/RootRegister.vue');
const KeyValues = () => import('./views/Admin/KeyValues.vue');
const AdminArticles = () => import('./views/Admin/Articles.vue');
const PublicHolidays = () => import('./views/Admin/PublicHolidays.vue');
const UserCustomers = () => import('./views/Admin/UserCustomers.vue');

const ProtocolDetails = () => import('./views/ProtocolDetails.vue');

const ReportsList = () => import('./views/Reports/List.vue');
const AdminReportsList = () => import('./views/Admin/Reports/List.vue');
const PriceList = () => import('./views/Admin/PriceList.vue');

const ResourcesOverview = () => import('./views/ResourcesOverview.vue');

const AdminResources = () => import('./views/Admin/Resources.vue');

const NotAllowed = () => import('./views/Messages/NotAllowed.vue');
const NotFound = () => import('./views/Messages/NotFound.vue');

const awaitLoadedUser = (callback) => {
    if (!store.state.user.isLoading) callback()
    const unwatch = store.watch((state) => state.user.isLoading, () => {
        unwatch()
        callback()
    })
}

const isAdminRouteGuard = (to, from, next) => {
    awaitLoadedUser(() => {
        if (!store.state.user.isAdmin) {
            next({ name: 'not-allowed' })
        } else {
            next()
        }
    })
}

const isCustomerAdminRouteGuard = (to, from, next) => {
    awaitLoadedUser(() => {
        if (!store.state.user.isCustomerAdmin) {
            next({ name: 'not-allowed' })
        } else {
            next()
        }
    })
}

const router = createRouter({
    history: createWebHashHistory(process.env.VUE_APP_URL),
    routes: [
        {
            path: '/',
            redirect: "/dashboard"
        },
        // *** Messages ***
        {
            // 404 page
        
            path: '/:pathMatch(.*)*',
            name: 'not-found',
            component: NotFound
        },

        {
            // 401 page
            path: '/not-allowed',
            name: 'not-allowed',
            component: NotAllowed
        },
        // *** Time overview
        {
            path: '/week',
            name: 'week',
            component: WeekOverview
        },
        {
            path: '/week/:from/:to',
            name: 'week2',
            component: WeekOverview
        },

        /*   {
             path: '/dashboard',
             name: 'dashboard',
             component: Dashboard
           },*/

        // *** Classic view
        {
            path: '/classic/:pageId',
            name: 'classic',
            component: ClassicView,
            props: (route) => {
                return {
                    pageId: route.params.pageId
                }
            }
        },

        // *** Errands 
        {
            path: '/request/:refTaskId?',
            name: 'errand-request',
            component: ErrandRequest,
            meta: { title: 'Begär ärende' }
        },
        {
            path: '/newerrand',
            name: 'create new errand',
            component: CreateErrand,
            meta: { title: 'Skapa ärende' }
        },
        {
            path: '/newerrandcustom',
            name: 'create-new-errand-custom',
            component: CreateErrandCustom,
            meta: { title: 'Skapa ärende' }
        },
        {
            path: '/tab/:tabId/errand/:errandId/mtab/:modalTabId',
            name: 'home3',
            component: () => /* webpackChunkName: "errands-overview" */import('./views/ErrandsOverview.vue'),
            props: (route) => {
                return {
                    selectedTab: Number(route.params.tabId),
                    selectedErrand: Number(route.params.errandId),
                    selectedModalTab: Number(route.params.modalTabId)
                }
            }
        },
        {
            path: '/tab',
            name: 'home',
            component: () => /* webpackChunkName: "errands-overview" */import('./views/ErrandsOverview.vue')
        },
        {
            path: '/onlocation',
            name: 'onlocation',
            component: () => /* webpackChunkName: "errandworklog-overview" */import('./views/ErrandWorkLogOverview.vue')
        },
        {
            path: '/tab/:tabId',
            name: 'home2',
            component: () => /* webpackChunkName: "errands-overview" */import('./views/ErrandsOverview.vue'),
            props: (route) => {
                return {
                    selectedTab: route.params.tabId
                }
            }
        },


        /// ****** CUSTOMER ADMIN AREA **** 
        {
            path: '/invoicesummary',
            name: 'invoicesummary',
            component: InvoiceSummaryList,
            beforeEnter: isCustomerAdminRouteGuard
        },
        {
            path: '/ResourceGroups',
            name: 'ResourceGroups',
            component: ResourceGroupsList,
            beforeEnter: isCustomerAdminRouteGuard
        },

        // ** Customers
        {
            path: '/customers',
            name: 'customers',
            component: CustomerList,
            beforeEnter: isCustomerAdminRouteGuard
        },
        {
            path: '/documents/:tab?',
            name: 'documents',
            component: DocumentIndex,
        },
        {
            path: '/customer/:customerNo/:tab',
            name: 'customer',
            component: CustomerDetails,
            beforeEnter: isCustomerAdminRouteGuard,
            props: (route) => {
                return {
                    tab: route.params.tab,
                    customerNo: route.params.customerNo,
                }
            }
        },
        {
            path: '/new-customer',
            name: 'new-customer',
            component: NewCustomer,
            beforeEnter: isCustomerAdminRouteGuard
        },

        /// **** projects ***
        {
            path: '/admin/projects',
            name: 'admin-projects',
            component: ProjectAdminOverview,
            beforeEnter: isCustomerAdminRouteGuard
        },
        {
            path: '/projects',
            name: 'projects',
            component: ProjectList,
            beforeEnter: isCustomerAdminRouteGuard            
        },
        {
            path: '/projects/:projectNo',
            name: 'projects-overview',
            component: ProjectOverview,
            beforeEnter: isCustomerAdminRouteGuard,
               props: (route) => {
                return {
                    projectNo: route.params.projectNo
                }
            }
        },
        /// ****** ADMIN AREA ****
        {
            path: '/codex-queue',
            name: 'codex-queue',
            component: CodexQueue,
            beforeEnter: isAdminRouteGuard
        },
        {
            path: '/message-queue-2',
            name: 'message-queue-2',
            component: MessageQueue2,
            beforeEnter: isAdminRouteGuard
        },
        {
            path: '/message-queue',
            name: 'message-queue',
            component: MessageQueue,
            beforeEnter: isAdminRouteGuard
        },
        {
            path: '/task-types',
            name: 'task-types',
            component: TaskTypeOverview,
            beforeEnter: isAdminRouteGuard
        },
        {
            path: '/root-register/:tab?',
            name: 'root-register',
            component: RootRegister,
            beforeEnter: isAdminRouteGuard,
            props: (route) => {
                return {
                    tab: route.params.tab
                }
            }
        },
        {
            path: '/alerts',
            name: 'alerts',
            component: KeyValues,
            beforeEnter: isAdminRouteGuard
        },
        {
            path: '/admin/articles',
            name: 'AdminArticles',
            component: AdminArticles,
            beforeEnter: isAdminRouteGuard
        },

        {
            path: '/dashboard/:tab?',
            name: 'dashboard',
            component: Start,
            props: (route) => {
                return {
                    tab: route.params.tab,
                }
            }
        },
        {
            path: '/dashboard-edit/:tab?/',
            name: 'dashboard-edit',
            component: DashboardEdit,
            props: (route) => {
                return {
                    tab: route.params.tab,
                }
            }
        },
        {
            path: '/articles',
            name: 'Articles',
            component: ArticlesOverview,
            beforeEnter: isCustomerAdminRouteGuard
        },
        {
            path: '/articles/favorites/:id?/:tab?',
            name: 'article-favorites',
            component: ArticleFavorites,
            beforeEnter: isCustomerAdminRouteGuard,
            props: (route) => {
                return {
                    id: route.params.id,
                    tab: route.params.tab,
                }
            }
        },
        {
            path: '/protocols/:id',
            name: 'protocol-details',
            component: ProtocolDetails,
            props: (route) => {
                return {
                    id: route.params.id,
                }
            }
        },
        {
            path: '/reports',
            name: 'report-list',
            component: ReportsList,
        },
        {
            path: '/admin/resources',
            name: 'admin-resources',
            component: AdminResources,
        },
        {
            path: '/admin/reports',
            name: 'admin-report-list',
            component: AdminReportsList,
        },
        {
            path: '/admin/public-holidays',
            name: 'admin-public-holidays',
            component: PublicHolidays,
        },
        {
            path: '/admin/user-customers',
            name: 'admin-user-customers',
            component: UserCustomers,
        },
        {
            path: '/pricelists',
            name: 'price-lists',
            component: PriceList,
        },
        {
            path: '/resourcesoverview',
            name: 'resources-overview',
            component: ResourcesOverview,
        },

    ]
});
//const router = createRouter({
//    history: createWebHistory(),
//    routes
//})

router.beforeEach((to, from, next) => {
    document.title = to.meta.title || 'KEYnet - ' + process.env.VUE_APP_TITLE
    next()
})

export default router
